// core
import React from "react";
import cx from "classnames";
import DocumentLink from "../../../../../common/components/Document/DocumentLink";
import { IDocument } from "../../../../interfaces/IDocument";

// interfaces
interface IQuoteTableDocumentContentProps {
    policyDoc: IDocument;
    brochureDoc: IDocument;
}

// functions

// rendering
const QuoteTableFooterContent: React.FC<IQuoteTableDocumentContentProps> = (props) => {
    const { brochureDoc, policyDoc } = props;

    return (
        <div className={cx(["layout-flex-column", "gap-xl"])}>
            {brochureDoc.documentUrl && (
                <DocumentLink
                    key={brochureDoc.documentUrl}
                    title={"Product brochure"}
                    documentUrl={brochureDoc.documentUrl}
                    thumbnailUrl={brochureDoc.thumbnailUrl}
                    // className="gap-s"
                    style="vertical"
                    className={cx(["text-feature", "gap-s"])}
                />
            )}
            {policyDoc.documentUrl && (
                <DocumentLink
                    key={policyDoc.documentUrl}
                    title={"Policy document"}
                    documentUrl={policyDoc.documentUrl}
                    thumbnailUrl={policyDoc.thumbnailUrl}
                    style="vertical"
                    className="text-feature"
                />
            )}
        </div>
    );
};

export default React.memo(QuoteTableFooterContent);
